app.service('productWarranty', function (productCardManager, warrantyEncouragement, productCardConfig, store, modal, productInstalmentsModal, warrantyChangeConflictModal, sessionStorage) {

	let $self;
	let $warrantyModeSwitch;
	let $warrantyListTypes, $warrantyListSubscription;
	let $noWarrantySelector;
	let $warrantyBoxes;
	let config;
	let $noSubscriptionOnInstalmentMessage;

	function init(props) {
		config = productCardConfig.getData();

		setElements(props);
		setEvents();
		setDefaultWarrantyPaymentType();

		warrantyChangeConflictModal.init();
		selectWarrantyOnProductUpsellingLoad();
	}

	function selectWarrantyOnProductUpsellingLoad(){
		if (store.data.instalmentWarrantyId) {
			selectWarranty({
				warrantyId: store.data.instalmentWarrantyId,
				warrantyAddedFrom: 'PRODUCT_CARD_INSTALLMENT_WITH_WARRANTY'
			});
			return;
		}
		const {productWarranty, lastSelectedWarrantyPaymentType, lastSelectedWarrantyId, lastSelectedwarrantyAddedFrom} = productCardManager.get();
		if (productWarranty.warrantyPaymentType === 'SUBSCRIPTION' && store.data.isInstalment) {
				selectNoWarranty();
				productCardManager.setLastSelectedWarranty(productWarranty.warrantyPaymentType, productWarranty.warranty, productWarranty.warrantyAddedFrom);
				$noSubscriptionOnInstalmentMessage.addClass('is-active');
		} else if (lastSelectedWarrantyPaymentType === 'SUBSCRIPTION' && lastSelectedWarrantyId) {
			selectWarranty({
				warrantyId: lastSelectedWarrantyId,
				warrantyPaymentType:  lastSelectedWarrantyPaymentType,
				warrantyAddedFrom:  lastSelectedwarrantyAddedFrom
			});
			productCardManager.clearLastSelectedWarranty();
		} else if (productWarranty.warranty){
			selectWarranty({
				warrantyId: productWarranty.warranty,
				warrantyPaymentType: store.data.isInstalment ? "ONE_TIME" : (lastSelectedWarrantyPaymentType || "POSTPONED"),
				warrantyAddedFrom: productWarranty.warrantyAddedFrom
			});
		}
		addClassBasedOnSubscriptionWarrantiesNumber();
	}

	function addClassBasedOnSubscriptionWarrantiesNumber() {
		$warrantyListSubscription.addClass(`columns-`+$('.warranty-option', $warrantyListSubscription).length);
	}

	function setElements(props) {
		$self = props.$el.find('.warranties-section');
		$warrantyListTypes = $self.find('.warranty-list');
		$warrantyListSubscription = $self.find('.warranty-list[data-payment-type=SUBSCRIPTION]');
		$warrantyModeSwitch = $self.find('.warranty-mode-switch input');
		$noWarrantySelector = $self.find('.no-warranty-selector');
		$warrantyBoxes = $self.find('.warranty-box');
		$noSubscriptionOnInstalmentMessage = $self.find('#js-no-subscription-on-instalment-message')
	}

	function setEvents() {
		if ($warrantyModeSwitch.length) {
			$warrantyModeSwitch.select3();
			$warrantyModeSwitch.on('selectOption', handleWarrantyPaymentTypeSelect);
		}

		$self.on('click', '.js-select-warranty', handleSelectWarrantyClick)
			.on('click', '.js-select-no-warranty', selectNoWarranty)
			.on('click', '.js-warranty-more', openWarrantyModal);
	}

	function setDefaultWarrantyPaymentType() {
		$warrantyListTypes.first().addClass('is-active');
	}

	function handleWarrantyPaymentTypeSelect() {
		let paymentType = $(this).val();
		productCardManager.setUserWarrantyPaymentType(paymentType);
		selectPaymentType(paymentType);

		const { productWarranty, userWarrantySelected} = productCardManager.get();
		const warrantyId = productWarranty.warranty;
		const warrantyAddedFrom = productWarranty.warrantyAddedFrom;
		if(warrantyId) {
			bindSelectedWarranty(warrantyId, paymentType, warrantyAddedFrom);
			return;
		}
		if(userWarrantySelected) bindSelectedWarranty(userWarrantySelected, paymentType, warrantyAddedFrom);
		hideWarrantyNotExistOnPaymentMessages();
	}

	function hideWarrantyNotExistOnPaymentMessages(){
		$self.find('.js-no-payment-message').removeClass('is-active');
	}

	function handleSelectWarrantyClick(e) {
		const warrantyId = +$(this).data('warrantyId');
		const warrantyAddedFrom = store.data.isInstalment ? 'PRODUCT_CARD_WARRANTY_SECTION_INSTALLMENT' : 'PRODUCT_CARD_WARRANTY_SECTION';
		const paymentType = $(this).data('paymentType');
		const paymentTypeText = paymentType === 'SUBSCRIPTION' ? 'SUBSKRYPCJA_' : paymentType === 'POSTPONED' ? 'MIESIECZNA_' : 'JEDNORAZOWA_';

		if (e.target.classList.contains('warranty-more')){
			UA.interaction('KP_Crossell', paymentTypeText + warrantyId + '_Wiecej', 'Klikniecie');
			return;
		};
		if ($(this).hasClass('is-active')) return;

		if (store.data.instalmentWarrantyId) {
			warrantyChangeConflictModal.handleWarrantyConflict(warrantyId);
			return;
		}

		if (store.data.isInstalment) {
			$noSubscriptionOnInstalmentMessage.removeClass('is-active');
		} else {
			hideWarrantyNotExistOnPaymentMessages();
		}

		selectWarrantyBox(warrantyId, paymentType);
		productCardManager.addWarranty(warrantyId, paymentType, warrantyAddedFrom);
		productCardManager.setUserWarranty(null);
		productCardManager.setUserWarrantyPaymentType(null);
		UA.interaction('KP_Crossell', paymentTypeText + warrantyId, 'Klikniecie');
	}

	function selectNoWarranty() {
		UA.interaction('KP_Crossell', 'Ochrona_brak', 'Kliknięcie');
		if (store.data.instalmentWarrantyId) {
			warrantyChangeConflictModal.handleWarrantyConflict();
			return;
		}

		$warrantyBoxes.removeClass('is-active');
		$noWarrantySelector.addClass('is-active');
		productCardManager.removeWarranty();
	}

	function selectWarrantyBox(warrantyId, paymentType) {
		$warrantyBoxes.removeClass('is-active');
		$noWarrantySelector.removeClass('is-active');
		const $warrantyBox = $warrantyBoxes.filter(`[data-warranty-id=${warrantyId}]`).filter(`[data-payment-type=${paymentType}]`);
		$warrantyBox.addClass('is-active is-visible').siblings().removeClass('is-visible');
	}

	function selectPaymentType(paymentType) {
		const $selectedList = $warrantyListTypes.filter(`[data-payment-type=${paymentType}]`);
		$selectedList.addClass('is-active');
		$warrantyListTypes.not($selectedList).removeClass('is-active');
	}

	function bindSelectedWarranty(warrantyId, paymentType, warrantyAddedFrom) {
		// 'warrantyAddedFrom' przekazywany z wybranej opcji .js-select-warranty podczas przełączania zakładki 'upselling tab' na KP (standard/installment)
		let sameWarrantyBox = $warrantyListTypes.filter(`[data-payment-type=${paymentType}]`).find(`[data-warranty-id=${warrantyId}]`)[0];
		if(sameWarrantyBox) {
			selectWarrantyBox(warrantyId, paymentType);
			productCardManager.addWarranty(warrantyId, paymentType, warrantyAddedFrom);
		} else {
			productCardManager.setUserWarranty(warrantyId);
			selectNoWarranty();
			$self.find(`.js-no-payment-message[data-type=${paymentType}]`).addClass('is-active');
		}
	}

	function openWarrantyModal() {
		const {productWarranty} = productCardManager.get();

		warrantyEncouragement.load({
			warrantyId: productWarranty.warranty,
			warrantyPaymentType: productWarranty.warrantyPaymentType,
			fromProductUpselling: true
		}, {
			productId: config.id,
			outletCategoryId: store.data.outletCategoryId,
			instalmentCode: store.data.instalmentCode,
			instalmentNumber: store.data.instalmentNumber
		}, function (data){ 
			data.warrantyAddedFrom = store.data.instalmentCode ? 'ENCOURAGEMENT_PRODUCT_CARD_MORE_INFO_INSTALLMENT' : 'ENCOURAGEMENT_PRODUCT_CARD_MORE_INFO';
			selectWarranty(data);
		});
	}

	function showSelectedWarranty(warrantyCategoryType, warrantyPaymentType, warrantyId) {
		//pierwszy element danego typu gwarancji, np. tylko z "one_time" i z danej kategorii, np. "FULL_PROTECTION"
		const $firstWarrantyOption = $self.find(`.js-select-warranty[data-payment-type=${warrantyPaymentType}][data-warranty-category=${warrantyCategoryType}]`).parent().first();
		//wybrana opcja gwarancji
		const $selectedWarrantyOption = $self.find(`.js-select-warranty[data-warranty-id=${warrantyId}][data-payment-type=${warrantyPaymentType}][data-warranty-category=${warrantyCategoryType}]`).parent();
		
		if ($selectedWarrantyOption.length && $firstWarrantyOption.length && !$selectedWarrantyOption.is($firstWarrantyOption)) {
			$selectedWarrantyOption.insertBefore($firstWarrantyOption);
			$firstWarrantyOption.appendTo($firstWarrantyOption.parent());
		}
	}

	function selectWarranty(data) {
		const {warrantyId, warrantyPaymentType = "ONE_TIME", noWarrantySelected = false, warrantyAddedFrom, warrantyCategoryType} = data;

		if (noWarrantySelected) {
			selectNoWarranty();
			return;
		}

		if (store.data.instalmentWarrantyId && store.data.instalmentWarrantyId !== warrantyId) {
			warrantyChangeConflictModal.handleWarrantyConflict(+warrantyId);
			return;
		}

		productCardManager.addWarranty(+warrantyId, warrantyPaymentType, warrantyAddedFrom);
		bindSelectedWarranty(+warrantyId, warrantyPaymentType, warrantyAddedFrom);
		selectWarrantyBox(warrantyId, warrantyPaymentType);
		$warrantyModeSwitch.val(warrantyPaymentType).change();
		selectPaymentType(warrantyPaymentType);
		showSelectedWarranty(warrantyCategoryType, warrantyPaymentType, warrantyId);
	}

	return {
		init,
		showModal: openWarrantyModal
	};
});